import SoleIcon from '~/assets/icons/Sole';
import tracked from '~/components/Tracked/index';

type ButtonStyle = 'compact' | 'normal';

type Props = {
  buttonStyle: ButtonStyle;
  productId: number;
  source: string;
};

const SellNowButton = ({ buttonStyle, productId, source }: Props) => {
  const href = `/marketplace/sell/listing/new/bulk?initialProductId=${productId}&source=${source}`;

  if (buttonStyle === 'compact') {
    return (
      <tracked.ExternalLink
        variant="none"
        name="SELL_NOW"
        className="transition-transform duration-200 ease-in-out hover:scale-125"
        pagePosition="Body"
        href={href}
      >
        <SoleIcon width="16" height="16" />
      </tracked.ExternalLink>
    );
  }

  return (
    <tracked.ExternalLink
      variant="none"
      name="SELL_NOW"
      pagePosition="Body"
      href={href}
      className="flex items-center gap-1 whitespace-nowrap rounded-lg border border-black bg-black px-4 py-2
        text-xs text-white"
    >
      <SoleIcon width="16" height="16" />
      <span className="border-l border-grey-read pl-1">Sell now</span>
    </tracked.ExternalLink>
  );
};

export default SellNowButton;
